// extracted by mini-css-extract-plugin
export default {"container":"CompanyThumbnail_container__JzmgE","titleWrapper":"CompanyThumbnail_titleWrapper__jHLXB"};